<template>
  <div class="content animate-panel" v-if="isReady">
    <div class="hpanel">
      <search />
      <router-view
        @handleClickViewVideo="handleClickViewVideo"
        >
      </router-view>
    </div>
    <upgrade-plan-modal
      v-if="isShowUpgradePlanModal"
      @close="closeUpgradePlanModal"
    />
  </div>
</template>
<script>
import Search from './components/Search'
import UpgradePlanModal from '@/view/warehouses/UpgradePlanModal'

export default {
  components: {
    Search,
    UpgradePlanModal
  },
  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    }
  },
  data () {
    return {
      loader: null,
      isReady: false,
      isShowUpgradePlanModal: false
    }
  },
  async mounted () {
    await this.init()
    this.$events.listen('handleError', (err, modalWidth = 400) => {
      this.$store.commit('toggleModal', {
        show: true,
        message: err,
        modalWidth: modalWidth
      })
    })
  },
  methods: {
    async init () {
      this.loader = this.$loading.show()
      await this.$store.dispatch('fetchVideoCategories')
      await this.$store.dispatch('fetchVideos')
      await this.loadYouTubeAPI()
      this.loader && this.loader.hide()
      this.isReady = true
    },
    loadYouTubeAPI () {
      return new Promise(resolve => {
        if (window.YT && window.YT.Player) {
          resolve()
          return
        }

        const tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        window.onYouTubeIframeAPIReady = () => resolve()
        document.body.appendChild(tag)
      })
    },
    handleClickViewVideo (video) {
      if (video.isTargetPremium && this.isBasicPlan) {
        this.openUpgradePlanModal()
        return false
      }
      this.$router.push({
        name: 'VideoPlayer',
        params: {
          id: video.id
        }
      })
    },
    openUpgradePlanModal () {
      this.isShowUpgradePlanModal = true
      $('#upgrade-plan-modal').modal('show')
    },
    closeUpgradePlanModal () {
      this.isShowUpgradePlanModal = false
      $('#upgrade-plan-modal').modal('hide')
    }
  },
  beforeDestroy () {
    this.$store.commit('clearStore')
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.hpanel {
  background-color: #fff;
  padding: 20px;
}
@media (max-width: 767px) {
  .hpanel {
    padding: 10px;
  }
}
</style>
<style>
@keyframes rotateY {
  0%   { transform: rotateY(0deg); }
  25%   { transform: rotateY(90deg); }
  50%   { transform: rotateY(180deg); }
  100% { transform: rotateY(360deg); }
}
.premium-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: rgba(207, 155, 0, 0.8);
  color: #000;
  font-size: 14px;
  padding: 5px;
  border-radius: 4px;
  z-index: 2;
  font-weight: bold;
  i.fa {
    animation: rotateY 2s linear infinite;
  }
}
</style>
<style>
.channel-avatar {
  min-width: 48px;
  width: 48px;
  height: 48px;
  background: url(https://yt3.ggpht.com/TFEmvOb7TXQQ_q7yIPgVBRkD74pT3qaWzGaWRYlDgii8gvX6A69rEqa25e4aCLSZbXliVwW-Wg=s48-c-k-c0x00ffffff-no-rj) no-repeat center center;
}
</style>



// WEBPACK FOOTER //
// src/view/video/Video.vue